import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.modules.scss';

const SwapButton = (props) => (
    <div 
        className={styles['swap']} 
        {...props}
    >
        <svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
            <path 
                d="M0 0h24v24H0z" 
                fill="none" 
            />
        </svg>
    </div>
);

SwapButton.propTypes = {
    onClick: PropTypes.func,
};

export default SwapButton;
